import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { ArrowRightAltOutlined, ReportGmailerrorredOutlined } from '@mui/icons-material';
import { CSSProperties } from '@material-ui/styles/withStyles';
import { Link } from 'react-router-dom';

import { white } from 'utils/color-styles';
import { currencyFormat } from 'utils/currencyFormat';
import { PayrollRunFlatFile } from 'generated/graphql';
import { BackButton } from 'components/BackButton/BackButton';

const dateEntryStyle: CSSProperties = { fontSize: 12, fontWeight: 'normal', marginBottom: '10px' };
const highlightStyle: CSSProperties = { fontSize: 12, fontWeight: 'normal', marginBottom: '20px' };

export const PayrollRunHeader = ({
  payrollRun,
  title,
  paygroup,
}: {
  payrollRun: PayrollRunFlatFile;
  title: string;
  paygroup: string;
}) => {
  if (!payrollRun) {
    return null;
  }
  return (
    <Paper
      style={{
        padding: '28px 36px',
        marginBottom: 40,
        backgroundColor: white,
        backgroundSize: 'contain',
        backgroundPositionX: '90%',
        minHeight: 200,
        borderRadius: 16,
      }}
    >
      <div>
        <div
          style={{
            zIndex: 1,
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            marginBottom: '30px',
          }}
        >
          <Link to={`/donations/payroll?paygroup=${paygroup}`}>
            <BackButton />
          </Link>
          <Typography style={{ fontSize: 40, fontWeight: 'bold' }}>{title}</Typography>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <Typography style={dateEntryStyle}>
              Pay Period Dates:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {moment(payrollRun.startDateExternal).format('ll')}
                <ArrowRightAltOutlined />
                {moment(payrollRun.endDateExternal).format('ll')}
              </span>
            </Typography>
            <Typography style={dateEntryStyle}>
              Last Date for Deductions:{' '}
              <span style={{ fontWeight: 'bold' }}>{moment(payrollRun.endDate).format('ll')}</span>
            </Typography>
            <Typography style={dateEntryStyle}>
              File due date:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {moment(payrollRun.payDate).add(1, 'days').format('ll')}
              </span>
            </Typography>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px' }}>
            <div>
              <div style={highlightStyle}>
                <Typography style={{ fontSize: '20px' }}>
                  {currencyFormat(payrollRun.stats.totalUsd, 'USD')}
                </Typography>
                <Typography>Completed, Total Amount deducted from Payroll</Typography>
              </div>
              <div style={highlightStyle}>
                <Typography style={{ fontSize: '20px', color: '#C62828' }}>
                  {currencyFormat(
                    payrollRun.stats.totalUsd - payrollRun.stats.totalUsdSuccess,
                    'USD'
                  )}
                </Typography>
                <Typography>Unresolved/Unsuccessful Donation Amount</Typography>
              </div>
            </div>
            <div>
              <div style={highlightStyle}>
                <Typography style={{ fontSize: '20px' }}>
                  {payrollRun.stats.donationCountSuccess}
                </Typography>
                <Typography>Completed, Total Number of Deductions</Typography>
              </div>
              <div style={highlightStyle}>
                <Typography style={{ fontSize: '20px', color: '#C62828' }}>
                  <ReportGmailerrorredOutlined />{' '}
                  {payrollRun.stats.donationCount - payrollRun.stats.donationCountSuccess}
                </Typography>
                <Typography>Total Number of Unresolved/Unsuccessful Deductions</Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default PayrollRunHeader;
